/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SsoCheckMutationRequest,
  SsoCheckMutationResponse,
  SsoCheck400,
} from '../types/SsoCheck'

function getSsoCheckUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/sso/check/` as const }
  return res
}

/**
 * @description Check if the provided email requires SSO.
 * Request body:
 * email: str - User's email address
 * Returns:
 * sso_required: bool - Whether SSO is required
 * sso_configured: bool - Whether SSO is configured for this company
 * sso_url: str - URL to redirect for SSO (if required and configured)
 * company_name: str - Name of the company
 * error: str - Error message if SSO is not properly configured
 * @summary Check whether an email requires SSO
 * {@link /api/v1/auth/sso/check/}
 */
export async function ssoCheck(
  data?: SsoCheckMutationRequest,
  config: Partial<RequestConfig<SsoCheckMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SsoCheckMutationResponse,
    ResponseErrorConfig<SsoCheck400>,
    SsoCheckMutationRequest
  >({
    method: 'POST',
    url: getSsoCheckUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
